import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import TokenGate from './components/TokenGate';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <TokenGate>
        <App />
      </TokenGate>
    </BrowserRouter>
  </React.StrictMode>
);
